module.exports = __webpack_public_path__ + "static/media/dialtone-icon.38c85923.svg";